/* eslint-disable no-constant-condition */
// require("es6-promise").polyfill();
import Vue from "vue";
import App from "./App.vue";

// import directives from "./directives";
import { router } from "./router";
// import { Cookies } from "@/utils/auth";
import Vant from "vant";
import "vant/lib/index.less";
import "@/assets/less/index.less";
import "@/assets/less/vant/index.less";
// import { store } from "./store";

Vue.use(Vant);
// Vue.use(directives);

import { Lazyload } from "vant";
Vue.use(Lazyload, {
  error: "/static/error.png",
  loading: "/static/loading.png"
});

Vue.config.productionTip = false;

import mixins from "./mixins";
Vue.use(mixins);

new Vue({
  el: "#app",
  router,
  // store,
  ...App
});
